(function($) {
    $(function() {
        $(".dynamic-contact-data-reason").parent().append('<div class="form-columns-container two-to-one"><div id="formColumnFormFields"></div><div id="formColumnExtraData"></div></div>');
        $(".dependent-field").appendTo("#formColumnFormFields");
        setTimeout(function() {
            $("input, textarea").trigger("input");
            $('input[type="submit"]').closest(".gform_footer").addClass("hide-field dependent-field");
        }, 100);
        var lookup;
        var $dynamicDataPlace = $("#dynamicDataPlace");
        var $formSelects = $(".dynamic-contact-data-reason select").on("change", function() {
            var $select = $(this);
            $(".phone-block").addClass("hide-until-shown");
            $(".consent-field input").prop("checked", false);
            $(".dependent-field").addClass("hide-field");
            $(".show-form-button").addClass("hide-field");
            $dynamicDataPlace.empty();
            var $extraData = $("#formColumnExtraData").empty();
            setTimeout(function() {          // wait for GravityForms to have executed its conditional display
                var $visibleSelects = $formSelects.filter(":visible");
                var allSelected = $visibleSelects.length > 0;
                var selectValues = [];
                $visibleSelects.each(function() {
                    if(this.selectedIndex > 0) {
                        selectValues.push(this.value);
                        return true;
                    }
                    allSelected = false;
                    return false;
                });
                if(allSelected) {
                    lookup = dynamicContactDataMapping || {};
                    let index = 0;
                    while(index < selectValues.length) {
                        var value = selectValues[index++];
                        if(lookup.hasOwnProperty(value)) {
                            lookup = lookup[value];
                        } else {
                            break;
                        }
                    }
                    if(index === selectValues.length && lookup.hasOwnProperty("contents")) {
                        $dynamicDataPlace.addClass("loading").html('<div id="loader"></div>');
                        let contents = [];
                        let fetchs = [];
                        Array.isArray(lookup.contents) && lookup.contents.forEach((slug, index) => {
                            fetchs.push(fetch("/dynamic-contact-form/" + slug).then(response => response.text()).then(text => {
                                contents[index] = text;
                            }));
                        });
                        Promise.all(fetchs).then(() => {
                            $dynamicDataPlace.html(contents.join("")).removeClass("loading");
                            $(".schema-faq-question").off("click", openFaq).on("click", openFaq);
                            $(".downloadkategorie").off("click", openDownload).on("click", openDownload);
                            if($select.closest(".last-reason").length > 0 || $select.val() === "Kommune") {
                                if(lookup.form) {
                                    $(".dependent-field.hide-field").removeClass("hide-field");
                                    $extraData.empty();     // empty again because missing required field logic triggers every select resulting in multiple executions here
                                    var data = JSON.parse(sessionStorage.getItem("formToTrack") || "{}");
                                    var select1value = data?.kundenart;
                                    var select2value = data?.kunden_anfrage;
                                    if(select1value !== selectValues[0] || selectValues.length > 1 && select2value !== selectValues[1]) {
                                        data = {
                                            "kundenart": selectValues[0],
                                            "kunden_anfrage": selectValues.length > 1 ? selectValues[1] : ""
                                        };
                                        prepareFormTracking(data);
                                        if(typeof dataLayer !== "undefined") {
                                            data["event"] = "form_start";
                                            dataLayer.push(data);
                                        }
                                    }
                                    lookup.phoneblocks.forEach(phoneblock => {
                                        $(".phone-block." + phoneblock).removeClass("hide-until-shown").clone(true).appendTo($extraData);
                                    });
                                }
                            }
                        });
                    }
                }
            }, 100);
        });
        $(".dynamic-contact-data-reason select").trigger("change");
    });
})(jQuery);